import { render } from "./NumberConfig.vue?vue&type=template&id=3268e218&ts=true"
import script from "./NumberConfig.vue?vue&type=script&lang=ts"
export * from "./NumberConfig.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/soctio/singlepage/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__